import "./css/app.scss";

/* -----------------------------------------
  IMPORT JS
----------------------------------------- */

// Utility
import browserClasses from "./js/utils/bowser";
import lazyLoad from "./js/utils/lazy";
import { isInView, isInViewVideo } from "./js/utils/inview";
import windowHeightInit from "./js/utils/window-height";

// Components
import cPopup from "./js/components/c-popup";
import cTabs from "./js/components/c-tabs";
import cToggleBlock from "./js/components/c-toggle-block";
import cProducts from "./js/components/c-products";
import cRecipes from "./js/components/c-recipes";
import cSideMenu from "./js/components/c-side-menu";
import cCollapse from "./js/components/c-collapse";
import cGifts from "./js/components/c-gifts";
import cCollapseSustainability from "./js/components/c-collapse-sustainability";
import cVideo from "./js/components/c-video";
import cFooter from "./js/components/c-footer";
import Header from "./js/components/Header";
import cMapOffices from "./js/components/c-map-offices";
import Tabs from "./js/components/tabs";
import cSustainability from "./js/components/c-sustainability";
import customSelect from "./js/components/custom-select";
import cIngredients from "./js/components/c-ingredients";
import dataLayerScript from "./js/utils/dataLayer";

// Blocks
//import this from './js/blocks/hero

// Pages
//import this from './js/pages/home'

/* -----------------------------------------
  INIT
----------------------------------------- */

const initScripts = {
  init: function () {
    // Utility
    browserClasses();
    lazyLoad();
    isInView();
    isInViewVideo();
    windowHeightInit();

    // Components
    cPopup();
    cTabs();
    cToggleBlock();
    cProducts();
    cRecipes();
    cSideMenu(".recipes-description");
    cSideMenu(".privacy-policy");
    cCollapse();
    cGifts();
    cCollapseSustainability();
    cVideo();
    cFooter();
    cMapOffices();
    cSustainability();
    customSelect();
    cIngredients();
  
    Tabs();
    
    cRecipes()

    // Pages
    // this()

    Header();
  
    // document.addEventListener('DOMContentLoaded', function () {
    //   dataLayerScript();
    //
    //   console.log('DOMContentLoaded')
    // })
  },
};

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    initScripts.init();
  },
  { once: true }
)
